import * as React from "react";
import { Row, Col, InputGroup, Tooltip, OverlayTrigger } from "react-bootstrap";
import { SearchIcon } from "../../components/ui/icons";
import TableView from "../../components/tableView";
import useUserTable from "./useUserTable";
import UsersColumn from "./usersColumns";
import DebouncedInput from "../../components/tableView/debouncedInput";
import InviteUserModal from "../../components/inviteUserModal";
import EnableMobileLicensing from "../../components/enableMobileLicensing";
import "./users.scss";
import EditUserModal from "../../components/updateUserModal";
import { isDirectAdmin } from "../../common/utils";
import { IBaseLicenseDetails } from "../../common/types/mobileLicensingTypes";

const Users: React.FC<IProps> = () => {
  const {
    rows,
    globalFilter,
    setGlobalFilter,
    noDataMessage,
    handleReinvite,
    organisationLicensingDetails,
  } = useUserTable();
  const columns = UsersColumn(handleReinvite);
  const licenseDetailsKey =
  Object.keys(organisationLicensingDetails).find(
    (key) => key !== "type" && key !== "name"
  ) ?? "";

const licenseDetails: IBaseLicenseDetails =
  licenseDetailsKey && organisationLicensingDetails[licenseDetailsKey] as IBaseLicenseDetails;

  return (
    <div className="admin-users-container">
      <Col>
        <div className="dm-heading-container">
          <Row>
            <Col sm={2}>
              <div className="heading">Users</div>
            </Col>
            <Col sm={10}>
              <div className="users-add-role-container">
                <div className="user-search-input">
                  <InputGroup>
                    <DebouncedInput
                      value={globalFilter ?? ""}
                      onChange={(value) => setGlobalFilter(String(value))}
                      placeholder="Search for Users"
                      aria-label="Recipient's username"
                      aria-describedby="alerts-search"
                    />
                    <InputGroup.Text id="alerts-search">
                      <SearchIcon />
                    </InputGroup.Text>
                  </InputGroup>
                </div>
                {isDirectAdmin() && licenseDetails && (
                  <div className="enable-mob-license">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        !licenseDetails?.mobileLicenseDetails?.isActive ||
                        false ? (
                          <Tooltip id="disabled-license-tooltip">
                            Mobile license disabled. Please contact the Mimo
                            team for further details.
                          </Tooltip>
                        ) : (
                          <></>
                        )
                      }
                    >
                      <span>
                        <EnableMobileLicensing
                          users={rows}
                          licenseDetails={
                            licenseDetails?.mobileLicenseDetails || []
                          }
                          disabled={
                            !licenseDetails?.mobileLicenseDetails?.isActive ||
                            false
                          }
                        />
                      </span>
                    </OverlayTrigger>
                  </div>
                )}

                <div className="user-add-role-btn">
                  <InviteUserModal />
                  {/* <Modal4CreateNewOrgAdmin/> 
                  <Modal4EditNewOrgAdmin/>   */}
                  {/* <Modal4OrgAdminEnroll/>*/}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
      <Col>
        <div className="dm-body">
          <Row className="mb-3">
            <Col sm={5}></Col>
          </Row>
          <Row>
            <Col sm={12}>
              <div className="dm-table-container">
                <TableView
                  data={rows}
                  columns={columns}
                  globalFilter={globalFilter}
                  setGlobalFilter={setGlobalFilter}
                  noDataMessage={noDataMessage}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Col>
      <EditUserModal></EditUserModal>
    </div>
  );
};

export interface IProps {
  children: React.ReactNode;
}

export default Users;
